var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flags",
    d: "M5.14506 6.38671H3.48227C2.97703 6.38671 2.49738 6.64054 2.16802 7.08473L0.0671512 9.90668C1.59564 10 3.19448 10 4.32006 10C10.175 10 11 5.79321 11 3.82232C10.4916 4.54274 9.06221 6.38671 5.14186 6.38671H5.14506ZM10.2773 0.00373264C10.2517 0.347144 10.0887 1.75439 6.66076 1.75439C3.87238 1.75439 2.7468 1.75439 0 1.69093L2.0593 4.45315C2.45901 4.99067 3.03459 5.30422 3.64535 5.31168C4.32645 5.32288 5.26017 5.33408 5.41366 5.33408C8.9343 5.33408 10.9105 3.44905 10.9105 1.6424C10.9105 0.892124 10.6962 0.358343 10.2805 0L10.2773 0.00373264Z",
    fill: "#2949E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/flags.3ce888ef48a0159ab72e4e0775632e3c.svg";
export { ForwardRef as ReactComponent };